/** Whole years added before the original January opening, preserving historical event dates. */
export const SCENARIO_PREPARATION_MONTHS: Record<number, number> = {
  105: 12,
  108: 12,
  110: 12,
  111: 24,
  113: 24,
  114: 24,
  115: 36,
};
